import React from "react";
import { Link } from "react-router-dom";

const FooterAreaTwo = ({ socials, email, phone, address, about_us }) => {
  const formatPhoneNumber = (number) => {
    // Remove non-numeric characters
    return number.replace(/[^\d]/g, "");
  };
  // Format the phone number
  const formattedNumber = formatPhoneNumber(phone);
  const whatsappURL = `https://wa.me/1${formattedNumber}`;
  return (
    <footer
      className="footer-wrapper footer-layout2"
      style={{ backgroundImage: "url(assets/img/bg/footer-bg2-1.png)" }}
    >
      <div className="container">
        <div className="widget-area">
          <div className="row justify-content-between">
            <div className="col-md-12 col-xl-7">
              <div className="widget footer-widget widget-about">
                <h3 className="widget_title">About Us</h3>
                <p
                  className="footer-text mb-30"
                  dangerouslySetInnerHTML={{ __html: about_us }}
                ></p>
                <div className="social-btn style3">
                  {socials.map((social, index) => (
                    <a
                      key={index}
                      href={social.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      tabIndex={-1}
                    >
                      <i className={social.icon} />
                    </a>
                  ))}
                </div>
              </div>
            </div>
            <div className="col-md-6 col-xl-auto"></div>
            <div className="col-md-6 col-xl-auto">
              <div className="widget footer-widget">
                <h3 className="widget_title">Contact</h3>
                <div className="widget-contact2">
                  <div className="widget-contact-grid">
                    <div className="icon">
                      <i className="fas fa-map-marker-alt" />
                    </div>
                    <div className="contact-grid-details">
                      <p>Address</p>
                      <h6>
                        {address}
                        <p />
                      </h6>
                    </div>
                  </div>
                  <div className="widget-contact-grid">
                    <div className="icon">
                      <i className="fas fa-phone-alt" />
                    </div>
                    <div className="contact-grid-details">
                      <p>Phone Number</p>
                      <h6>
                        <Link to={whatsappURL}>{phone}</Link>
                        <p />
                      </h6>
                    </div>
                  </div>
                  <div className="widget-contact-grid">
                    <div className="icon">
                      <i className="fas fa-envelope" />
                    </div>
                    <div className="contact-grid-details">
                      <p>Email Address</p>
                      <h6>
                        <Link to={`mailto:${email}`}>{email}</Link>
                        <p />
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="copyright-wrap">
        <div className="container">
          <div className="row gy-3 justify-content-md-between justify-content-center">
            <div className="col-auto align-self-center">
              <p className="copyright-text text-center">
                © <Link to="#">Z Div Solutions</Link> 2025 | All Rights
                Reserved
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterAreaTwo;
